export const HISTORY_PLAN_CLIENT_LOADING_START = 'HISTORY_PLAN_CLIENT_LOADING_START';
export const GET_HISTORY_PLAN_CLIENT_SUCCESS = 'GET_HISTORY_PLAN_CLIENT_SUCCESS';
export const GET_HISTORY_PLAN_CLIENT_FAIL = 'GET_HISTORY_PLAN_CLIENT_FAIL';
export const HISTORY_PLAN_FREELANCER_LOADING_START = 'HISTORY_PLAN_FREELANCER_LOADING_START';
export const GET_HISTORY_PLAN_FREELANCER_SUCCESS = 'GET_HISTORY_PLAN_FREELANCER_SUCCESS';
export const GET_HISTORY_PLAN_FREELANCER_FAIL = 'GET_HISTORY_PLAN_FREELANCER_FAIL';
